import { windowsForApp } from '../../os/windows.svelte.js';
import { recentState } from '../../os/recents.svelte.js';
import { spacesState } from '../../os/spaces.svelte.js';

const baseMenuDefs = [
  {
    id: 'apple',
    label: 'Apple',
    items: [
      { label: 'About SMac OS X', app: 'about' },
      { separator: true },
      { label: 'System Preferences...', app: 'control-panel' },
      { separator: true },
      { label: 'Enter Sandbox (Fullscreen)', command: { type: 'enter-sandbox' } },
      { separator: true },
      { label: 'Log Out...', command: { type: 'logout' } },
      { separator: true },
      { label: 'Sleep', command: { type: 'sleep' } },
      { label: 'Restart...', command: { type: 'restart' } },
      { label: 'Shut Down...', command: { type: 'shutdown' } },
    ],
  },
  {
    id: 'finder',
    label: 'Finder',
    strong: true,
    items: [
      { label: 'About Finder', disabled: true },
      { separator: true },
      { label: 'Preferences...', disabled: true, shortcut: ',' },
      { separator: true },
      { label: 'Empty Trash', command: { type: 'empty-trash' } },
    ],
  },
  {
    id: 'file',
    label: 'File',
    items: [
      { label: 'New Finder Window', app: 'projects', shortcut: 'N' },
      { label: 'New Folder', command: { type: 'new-folder' }, shortcut: 'Shift+N' },
      { recentItems: true },
      { separator: true },
      { label: 'Get Info', command: { type: 'quick-look' }, shortcut: 'I' },
    ],
  },
  {
    id: 'edit',
    label: 'Edit',
    items: [
      { label: 'Undo', command: { type: 'app-command', action: 'undo' }, shortcut: 'Z' },
      { label: 'Redo', command: { type: 'app-command', action: 'redo' }, shortcut: 'Shift+Z' },
      { separator: true },
      { label: 'Cut', command: { type: 'app-command', action: 'cut' }, shortcut: 'X' },
      { label: 'Copy', command: { type: 'app-command', action: 'copy' }, shortcut: 'C' },
      { label: 'Paste', command: { type: 'app-command', action: 'paste' }, shortcut: 'V' },
      { separator: true },
      {
        label: 'Select All',
        command: { type: 'app-command', action: 'select-all' },
        shortcut: 'A',
      },
      { separator: true },
      { label: 'Content Editor', app: 'content-editor' },
    ],
  },
  {
    id: 'view',
    label: 'View',
    items: [
      { label: 'as Icons', command: { type: 'view', view: 'icons' } },
      { label: 'as List', command: { type: 'view', view: 'list' } },
      { label: 'as Columns', command: { type: 'view', view: 'columns' } },
      { label: 'as Cover Flow', command: { type: 'view', view: 'cover' } },
    ],
  },
  {
    id: 'go',
    label: 'Go',
    items: [
      { label: 'Welcome', app: 'welcome' },
      { label: 'Projects', app: 'projects' },
      { label: 'Resume', app: 'resume' },
      { label: 'Contact', app: 'contact' },
    ],
  },
  {
    id: 'window',
    label: 'Window',
    items: [
      { label: 'Minimize', command: { type: 'minimize' }, shortcut: 'M' },
      { label: 'Exit Full Screen', command: { type: 'exit-window-mode' }, shortcut: 'Esc' },
      { separator: true },
      { label: 'Cascade', command: { type: 'cascade' } },
      { label: 'Tile All', command: { type: 'tile-all' } },
      { separator: true },
      { label: 'Tile Window to Left of Screen', command: { type: 'tile-left' } },
      { label: 'Tile Window to Right of Screen', command: { type: 'tile-right' } },
      { separator: true },
      { label: 'Mission Control', command: { type: 'mission-control' }, shortcut: 'Ctrl+↑' },
      { label: 'Previous Desktop', command: { type: 'previous-space' }, shortcut: 'Ctrl+←' },
      { label: 'Next Desktop', command: { type: 'next-space' }, shortcut: 'Ctrl+→' },
      { separator: true },
      { label: 'Global Chat', app: 'chat' },
      { label: 'Graphite Tiles', app: 'game' },
    ],
  },
  {
    id: 'help',
    label: 'Help',
    items: [
      { label: 'SMac OS X Help', app: 'welcome' },
      { label: 'About This Mac', app: 'about' },
    ],
  },
];

function appSpecificMenus(appDef) {
  const documentApp = ['documents', 'media', 'dev'].includes(appDef.category);
  const finder = appDef.id === 'projects';
  const browser = appDef.id === 'safari';
  const previewFileItems = [
    { label: 'Open...', command: { type: 'app-command', action: 'open' }, shortcut: 'O' },
    { separator: true },
    { label: 'Export...', command: { type: 'app-command', action: 'export' }, shortcut: 'E' },
    { label: 'Print', command: { type: 'app-command', action: 'print' }, shortcut: 'P' },
    { separator: true },
    { label: 'Close Window', command: { type: 'close-window' }, shortcut: 'W' },
  ];
  const browserFileItems = [
    { label: 'New Browser Window', command: { type: 'new-window' }, shortcut: 'N' },
    { label: 'New Tab', command: { type: 'app-command', action: 'new-tab' }, shortcut: 'T' },
    { label: 'Close Tab', command: { type: 'app-command', action: 'close-tab' }, shortcut: 'W' },
    { separator: true },
    { label: 'Print…', command: { type: 'app-command', action: 'print' }, shortcut: 'P' },
    { separator: true },
    { label: 'Close Window', command: { type: 'close-window' } },
  ];
  const fileItems = finder
    ? [
        { label: 'New Finder Window', command: { type: 'new-window' }, shortcut: 'N' },
        { label: 'New Folder', command: { type: 'new-folder' }, shortcut: 'Shift+N' },
        { recentItems: true },
        { separator: true },
        { label: 'Get Info', command: { type: 'app-command', action: 'get-info' }, shortcut: 'I' },
        { separator: true },
        { label: 'Mount Real Folder…', command: { type: 'mount-real-dir' } },
      ]
    : appDef.id === 'preview'
      ? previewFileItems
      : browser
        ? browserFileItems
        : [
            { label: `New ${appDef.label} Window`, command: { type: 'new-window' }, shortcut: 'N' },
            ...(documentApp
              ? [
                  {
                    label: 'Open...',
                    command: { type: 'app-command', action: 'open' },
                    shortcut: 'O',
                  },
                ]
              : []),
            { separator: true },
            { label: 'Close Window', command: { type: 'close-window' }, shortcut: 'W' },
          ];
  return [
    { id: 'file', label: 'File', items: fileItems },
    {
      id: 'edit',
      label: 'Edit',
      items: [
        { label: 'Undo', command: { type: 'app-command', action: 'undo' }, shortcut: 'Z' },
        { separator: true },
        { label: 'Cut', command: { type: 'app-command', action: 'cut' }, shortcut: 'X' },
        { label: 'Copy', command: { type: 'app-command', action: 'copy' }, shortcut: 'C' },
        { label: 'Paste', command: { type: 'app-command', action: 'paste' }, shortcut: 'V' },
        {
          label: 'Select All',
          command: { type: 'app-command', action: 'select-all' },
          shortcut: 'A',
        },
      ],
    },
    {
      id: 'view',
      label: 'View',
      items: finder
        ? baseMenuDefs.find((menu) => menu.id === 'view').items
        : appDef.id === 'preview'
          ? [
              {
                label: 'Zoom In',
                command: { type: 'app-command', action: 'zoom-in' },
                shortcut: '=',
              },
              {
                label: 'Zoom Out',
                command: { type: 'app-command', action: 'zoom-out' },
                shortcut: '-',
              },
              { separator: true },
              {
                label: 'Rotate Right',
                command: { type: 'app-command', action: 'rotate-right' },
                shortcut: 'R',
              },
              {
                label: 'Rotate Left',
                command: { type: 'app-command', action: 'rotate-left' },
                shortcut: 'L',
              },
              { separator: true },
              {
                label: 'Enter Full Screen',
                command: { type: 'toggle-fullscreen' },
                shortcut: 'Ctrl+F',
              },
            ]
          : browser
            ? [
                { label: 'Stop', command: { type: 'app-command', action: 'stop' } },
                {
                  label: 'Reload Page',
                  command: { type: 'app-command', action: 'reload' },
                  shortcut: 'R',
                },
                { separator: true },
                {
                  label: 'Make Text Bigger',
                  command: { type: 'app-command', action: 'text-larger' },
                  shortcut: '+',
                },
                {
                  label: 'Actual Size',
                  command: { type: 'app-command', action: 'text-normal' },
                  shortcut: '0',
                },
                {
                  label: 'Make Text Smaller',
                  command: { type: 'app-command', action: 'text-smaller' },
                  shortcut: '-',
                },
                { separator: true },
                {
                  label: 'Enter Full Screen',
                  command: { type: 'toggle-fullscreen' },
                  shortcut: 'Ctrl+F',
                },
              ]
            : [
                {
                  label: 'Enter Full Screen',
                  command: { type: 'toggle-fullscreen' },
                  shortcut: 'Ctrl+F',
                },
              ],
    },
    ...(finder ? [baseMenuDefs.find((menu) => menu.id === 'go')] : []),
    ...(browser
      ? [
          {
            id: 'go',
            label: 'Go',
            items: [
              { label: 'Back', command: { type: 'app-command', action: 'go-back' }, shortcut: '[' },
              {
                label: 'Forward',
                command: { type: 'app-command', action: 'go-forward' },
                shortcut: ']',
              },
              { separator: true },
              {
                label: 'Home',
                command: { type: 'app-command', action: 'go-home' },
                shortcut: 'Shift+H',
              },
            ],
          },
          {
            id: 'favorites',
            label: 'Favorites',
            items: [
              {
                label: 'Add to Favorites',
                command: { type: 'app-command', action: 'add-favorite' },
                shortcut: 'D',
              },
              {
                label: 'Show Favorites Bar',
                command: { type: 'app-command', action: 'toggle-links' },
              },
              { separator: true },
              { label: 'Favorites', heading: true },
            ],
          },
          {
            id: 'history',
            label: 'History',
            items: [
              { label: 'Back', command: { type: 'app-command', action: 'go-back' } },
              { label: 'Forward', command: { type: 'app-command', action: 'go-forward' } },
              { separator: true },
              { label: 'Show All History', command: { type: 'app-command', action: 'history' } },
              { label: 'Clear History', command: { type: 'app-command', action: 'clear-history' } },
            ],
          },
        ]
      : []),
  ];
}

export function getMenuDefs(activeApp) {
  const appDef = activeApp;
  const dynamicMenus = [
    {
      id: 'apple',
      label: 'Apple',
      items: [
        { label: 'About SMac OS X', app: 'about' },
        { separator: true },
        { label: 'System Preferences...', app: 'control-panel' },
        { separator: true },
        { label: 'Enter Sandbox (Fullscreen)', command: { type: 'enter-sandbox' } },
        { separator: true },
        { label: 'Log Out...', command: { type: 'logout' } },
        { separator: true },
        { label: 'Sleep', command: { type: 'sleep' } },
        { label: 'Restart...', command: { type: 'restart' } },
        { label: 'Shut Down...', command: { type: 'shutdown' } },
      ],
    },
    {
      id: 'app-menu',
      label: appDef.label,
      strong: true,
      items: [
        { label: `About ${appDef.label}`, app: 'about' },
        { separator: true },
        { label: 'Preferences...', app: 'control-panel', shortcut: ',' },
        { separator: true },
        { label: `Hide ${appDef.label}`, command: { type: 'hide-app' }, shortcut: 'H' },
        { separator: true },
        { label: `Quit ${appDef.label}`, command: { type: 'quit-app' }, shortcut: 'Q' },
      ],
    },
    ...appSpecificMenus(appDef),
    {
      id: 'window',
      label: 'Window',
      items: [
        ...baseMenuDefs.find((m) => m.id === 'window').items,
        ...(spacesState.spaces.length > 1
          ? [
              { separator: true },
              { label: 'Move to Space', heading: true },
              ...spacesState.spaces.map((space) => ({
                label: space.name,
                command: { type: 'move-to-space', spaceId: space.id },
              })),
            ]
          : []),
        ...(windowsForApp(appDef.id).length ? [{ separator: true }] : []),
        ...windowsForApp(appDef.id).map((win) => ({
          label: win.title,
          command: { type: 'focus-window', id: win.id },
        })),
      ],
    },
    baseMenuDefs.find((m) => m.id === 'help'),
  ].filter(Boolean);

  return dynamicMenus.map((menu) => ({
    ...menu,
    items: (menu.items ?? []).flatMap((item) => {
      if (!item.recentItems) return [item];
      const recents = recentState.items.map((recent) => ({ label: recent.label, recent }));
      return [
        { separator: true },
        { label: 'Open Recent', heading: true },
        ...recents,
        ...(recents.length
          ? [{ label: 'Clear Menu', clearRecents: true }]
          : [{ label: 'No Recent Items', disabled: true }]),
      ];
    }),
  }));
}
